import { cn } from "@/lib/utils"

interface LogoLoaderProps {
  size?: "sm" | "md" | "lg" | "xl" | "huge"
  className?: string
  fullScreen?: boolean
}

export function LogoLoader({ 
  size = "md", 
  className,
  fullScreen = false 
}: LogoLoaderProps) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-16 h-16",
    lg: "w-32 h-32",
    xl: "w-64 h-64",
    huge: "w-96 h-96"
  }

  const content = (
    <div className={cn("relative", sizeClasses[size], className)}>
      {/* Gentle breathing pulse — subtle, not a sweeping shimmer */}
      <img
        src="/logo.png"
        alt="Loading..."
        className="absolute inset-0 w-full h-full object-contain animate-logo-pulse"
      />
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background z-[9999]">
        {content}
      </div>
    )
  }

  return content
}
